/**
* 生成订单
*/
<template>

  <div class="wrapper">

    <el-steps :active="3">
      <el-step title="生成订单"></el-step>
      <el-step title="支付订单"></el-step>
      <el-step title="支付成功"></el-step>
    </el-steps>

    <div class="content-wrapper">
      <img class="pay_success_img" src="@/assets/pay_success.png">
      <div class="pay_success_message">支付成功</div>
    </div>
  </div>

</template>

<script>

export default {

  methods: {

    gotoIndex() {

      console.log(123)
      this.$router.push("/manage/quota");
    }

  },
  mounted() {

    console.log(123)
    let that = this;
    setTimeout(function () {

      that.gotoIndex();
    }, 3000);//1000为1秒钟
  }


}


</script>

<style scoped>


.wrapper {
  padding: 2vw 3vw;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 2vw;
  height: 60vw;
}

.pay_success_img {
  width: 10vw;
  height: 10vw;
}

.pay_success_message {
  margin-top: 1vw;
  font-size: 0.9vw;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: start;

}


</style>




// WEBPACK FOOTER //
// src/views/pay/SuccessPayOrder.vue